module.exports = __webpack_public_path__ + "img/login-bg.5f18ba61.png";